/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_ProviderInputs */

const cs_col_provider = /** @type {(inputs: Col_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poskytovatel`)
};

const en_col_provider = /** @type {(inputs: Col_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Col_ProviderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_provider = /** @type {((inputs?: Col_ProviderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_ProviderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_provider(inputs)
	return cs_col_provider(inputs)
});